module.exports = __webpack_public_path__ + "img/舟山市.a2a8124f.png";